import { StyleSheet } from 'react-native';
import theme from '../../../common/theme';
import { ThemeColors } from '../../../common/theme-colors';

export const getStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    container: {
      flex: 1,
      rowGap: 60,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colors.elevation1,
    },
    text: {
      width: 480,
      rowGap: 8,
    },
    amountGroup: {
      width: '100%',
      rowGap: 32,
      alignItems: 'center',
    },
    title: {
      fontSize: 28,
      lineHeight: 44,
      textAlign: 'center',
      color: colors.text,
      fontVariant: ['tabular-nums'],
      fontFamily: theme.fonts.bold,
    },
    titleError: {
      color: colors.negative,
    },
    subtitle: {
      fontSize: 18,
      lineHeight: 30,
      textAlign: 'center',
      color: colors.textLight,
      fontVariant: ['tabular-nums'],
      fontFamily: theme.fonts.medium,
    },
    value: {
      fontSize: 42,
      lineHeight: 58,
      textAlign: 'center',
      color: colors.text,
      fontVariant: ['tabular-nums'],
      fontFamily: theme.fonts.semibold,
    },
    dismissBtn: {
      width: 300,
      alignItems: 'center',
      justifyContent: 'center',
      paddingVertical: 20,
      paddingHorizontal: 32,
      borderWidth: 1,
      borderRadius: theme.radius.m,
      borderColor: colors.border,
      backgroundColor: colors.elevation0,
    },
    dismissBtnText: {
      fontSize: 18,
      lineHeight: 26,
      textAlign: 'center',
      color: colors.text,
      fontVariant: ['tabular-nums'],
      fontFamily: theme.fonts.semibold,
    },
  });
